<template>
	<div class="conten">
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true">
				<el-form-item>
					<el-button type="primary" @click='add'>新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<div>
			<el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" row-key="pkPermsId" border
				 :tree-props="{children: 'child'}">
				<el-table-column prop="menuName" label="菜单名称">
				</el-table-column>
				<el-table-column prop="path" label="菜单路径" align="center">
				</el-table-column>
				<!-- <el-table-column prop="permsCode" label="菜单权限" align="center">
				</el-table-column> -->
				<el-table-column prop="permsSort" label="菜单排序" align="center">
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="300" align="center">
					<template slot-scope="scope">
						<el-button size="mini" type="primary" v-if='!scope.row.parentId'
							@click="addChildren(scope.row)">添加子级菜单</el-button>
						<el-button size="mini" @click="edit(scope.row)">编辑</el-button>
						<el-button size="mini" type="danger" @click="del(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-dialog :close-on-click-modal='false' :close-on-press-escape='false' :title="isAdd?'新增':'修改'" :visible.sync="dialogVisible" :modal-append-to-body='false' width="600px">
			<el-form :model="form">
				<el-form-item label="父级菜单" label-width='100px'>
					<el-input v-model="form.parentName" disabled autocomplete="off" placeholder=" "></el-input>
				</el-form-item>
				<el-form-item label="父级ID" label-width='100px' >
					<el-input v-model="form.parentId" disabled autocomplete="off" placeholder=" "></el-input>
				</el-form-item>
				<el-form-item label="菜单名称" label-width='100px'>
					<el-input v-model="form.menuName" autocomplete="off" placeholder="请输入菜单名称"></el-input>
				</el-form-item>
				<el-form-item label="菜单路径" label-width='100px'>
					<el-input v-model="form.path" autocomplete="off" placeholder="请输入菜单路径"></el-input>
				</el-form-item>
				<!-- <el-form-item label="权限码" label-width='100px'>
					<el-input v-model="form.permsCode" autocomplete="off" placeholder="请输入菜单权限"></el-input>
				</el-form-item> -->
				<el-form-item label="菜单排序" label-width='100px'>
					<el-input v-model.number="form.permsSort" autocomplete="off" placeholder="请输入菜单排序"></el-input>
				</el-form-item>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="sub()">确 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				tableData: [],
				dialogVisible: false,
				isAdd: true,
				form: {
					"menuName": "",
					"parentId": "",
					"parentName": "",
					"path": "",
					"permsCode": "",
					"permsSort": "",
					"pkPermsId": ""
				},

			}
		},
		created() {
			this.getMentList()
		},
		methods: {
			//新增
			add() {
				this.dialogVisible = true
				this.isAdd = true
				this.form ={
					"menuName": "",
					"parentId": "",
					"parentName": "",
					"path": "",
					"permsCode": "",
					"permsSort": "",
					"pkPermsId": ""
				}
			},
			//新增子级
			addChildren(row) {
				this.dialogVisible = true
				this.isAdd = true
				this.form ={
					"menuName": "",
					"parentId": row.pkPermsId,
					"parentName": row.menuName,
					"path": "",
					"permsCode": "",
					"permsSort": "",
					"pkPermsId": ""
				}
			},
			//确定提交
			sub(){
				if (this.form.menuName.length == 0) {
					this.$message('请输入菜单名称');
					return false
				}
				if (this.form.path.length == 0) {
					this.$message('请输入菜单路径');
					return false
				}
				if(this.form.permsSort.length!=0){
					if (!this.isNullNum(this.form.permsSort)) {
						this.$message('排序请输入为数字');
						return false
					}
				}
				
				this.form.permsCode=this.form.path
				var url=this.isAdd?"/system/menu/add":"/system/menu/update"
				if(this.isAdd){
					this.httpPost(url, this.form, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						if (res.code == 200) {
							this.$message.success('新增成功');
							this.dialogVisible = false
							this.getMentList()
						}
					})
				}else{
					this.httpPut(url, this.form, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						if (res.code == 200) {
							this.$message.success('修改成功');
							this.dialogVisible = false
							this.getMentList()
						}
					})
				}
			},
			
			
			//删除
			del(row) {
				console.log(row);
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.httpDel("/system/menu/del?" + this.$qs.stringify({
						pkPermsId: row.pkPermsId
					})).then(res => {
						if (res.code == 200) {
							this.$message.success('删除成功');
							this.getMentList()
						}
					})
				}).catch(() => {
				});
			},
			//修改
			edit(row) {
				console.log(row);
				this.dialogVisible = true
				this.isAdd = false
				this.form=JSON.parse(JSON.stringify(row))
			},
			getMentList() {
				this.httpPost("/system/menu/selectMenus").then(res => {
					if (res.code == 200) {
						this.tableData = res.data
					}
				})
			}

		},


	}
</script>

<style scoped>
</style>
